// extracted by mini-css-extract-plugin
export var contents = "PortfolioTop-module--contents--91eb3";
export var isDark = "PortfolioTop-module--is-dark--b755b";
export var phone = "PortfolioTop-module--phone--e4d6d";
export var phone__img = "PortfolioTop-module--phone__img--5aea5";
export var phone__inner = "PortfolioTop-module--phone__inner--a2e0f";
export var phone__object = "PortfolioTop-module--phone__object--3f0e8";
export var title = "PortfolioTop-module--title--d54a5";
export var wrap = "PortfolioTop-module--wrap--a806c";